import { loadGroup } from '@ms/yammer-data/dist/domains/groups/actions';
import { Group } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

type UseLoadGroup = (groupId: Group['id']) => void;
export const useLoadGroup: UseLoadGroup = (groupId) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadGroup(groupId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);
};
